import React, { useState } from 'react';
import { Form } from 'antd';
import { Input, Button, Checkbox } from '@gamesb42/ui-kit';

interface InvitePasswordFormData {
  password: string;
  confirmPassword: string;
  agree: boolean;
}

interface InvitePasswordFormProps {
  form: any;
  loading: boolean;
  onFinish: (values: InvitePasswordFormData) => void;
}

const InvitePasswordForm: React.FC<InvitePasswordFormProps> = ({
  form,
  loading,
  onFinish,
}) => {
  const [isAgreed, setIsAgreed] = useState(false);

  return (
    <>
      <h2
        style={{
          marginBottom: '20px',
          textAlign: 'left',
          color: '#090909',
          fontSize: '32px',
          fontWeight: 700,
          lineHeight: '40px',
          fontFamily: 'Muller',
        }}
      >
        Set Your Password
      </h2>

      <div style={{ marginBottom: '32px', color: '#606176' }}>
        Create a strong password with a mix of letters, numbers, and symbols
      </div>

      <Form form={form} layout="vertical" onFinish={onFinish} size="large">
        <Form.Item
          name="password"
          rules={[
            { required: true, message: 'Please input your password' },
            {
              min: 8,
              pattern:
                /^(?=.*[A-Za-z])(?=.*\d)(?=.*[@$!%*#?&])[A-Za-z\d@$!%*#?&]{8,}$/,
              message:
                'Password must be at least 8 characters and contain letters, numbers, and special characters (@$!%*#?&)',
            },
          ]}
        >
          <Input
            label="New Password"
            placeholder="Password*"
            size="large"
            type="password"
            autoComplete="new-password"
          />
        </Form.Item>

        <Form.Item
          name="confirmPassword"
          dependencies={['password']}
          rules={[
            { required: true, message: 'Please confirm your password!' },
            ({ getFieldValue }) => ({
              validator(_, value) {
                if (!value || getFieldValue('password') === value) {
                  return Promise.resolve();
                }
                return Promise.reject(
                  new Error('The two passwords do not match!'),
                );
              },
            }),
          ]}
        >
          <Input
            label="Confirm Password"
            placeholder="Confirm Password*"
            size="large"
            type="password"
            autoComplete="new-password"
          />
        </Form.Item>

        <Form.Item style={{ marginBottom: '32px' }}>
          <Checkbox
            checked={isAgreed}
            onChange={(e) => setIsAgreed(e.target.checked)}
            style={{
              alignItems: 'flex-start',
              color: 'var(--grey-gray-10-blue-grey, #686F88)',
              fontFamily: 'Muller',
              fontSize: '14px',
              fontStyle: 'normal',
              fontWeight: 400,
              lineHeight: '20px',
              textAlign: 'justify',
              paddingRight: 0,
            }}
          >
            By clicking the "Set Password" button, you are creating a
            GamesBoost42 account, and you agree to GamesBoost42's{' '}
            <a
              href="https://id.gamesboost42.com/resources/mm3fq/login/factoring/pdf/Terms_of_Service.pdf"
              style={{ color: '#5227cb' }}
              target="_blank"
              rel="noopener noreferrer"
            >
              Terms of Service
            </a>{' '}
            and{' '}
            <a
              href="https://id.gamesboost42.com/resources/mm3fq/login/factoring/pdf/Privacy_Policy.pdf"
              style={{ color: '#5227cb' }}
              target="_blank"
              rel="noopener noreferrer"
            >
              Privacy Policy
            </a>
          </Checkbox>
        </Form.Item>

        <Form.Item>
          <Button
            type="primary"
            htmlType="submit"
            loading={loading}
            size="large"
            violet
            disabled={!isAgreed}
            style={{
              color: '#fff',
              width: '130px',
            }}
          >
            Set Password
          </Button>
        </Form.Item>
      </Form>
    </>
  );
};

export default InvitePasswordForm;
